export default function isFalsyOrEmptyHtmlRichText(text: string | null | undefined): text is null | undefined {
  if (typeof text !== 'string') {
    return true;
  }
  if (text.length === 0) {
    return true;
  }
  const trimmedText = text.trim();
  return trimmedText.length === 0 || trimmedText === '<p></p>';
}
